import React from 'react';
import api from "utils/api";
import { Radio, Collapse, Empty, Card, message } from 'antd';
import utils from 'utils';
import "./Others.scss";
import { CONSTANTS } from "utils/constant";
import Loader from "Components/Loader";
const { Panel } = Collapse;

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
        };
    }

    getSummaryList() {
        this.setState({ isLoading: true });
        api
            .get_dsm_summary_list({ patient_id: this.props.data?.patient_id, type: this.props.data?.user_type })
            .then(res => {
                let { status, data: { results } } = res.data || {};
                if (status == 200) {
                    (results || []).forEach(m => {
                        (m.questions || []).forEach((n, i) => n["index"] = i + 1);
                    })
                    this.setState({
                        data: results, isLoading: false,
                    })
                }else{
                    message.error(res.data?.message, ErrorDuration);
                    this.setState({isLoading: false})
                }
            })
            .catch(err => { })
    }

    renderAssesment(item) {
        return (
            <div className='assessment-item'>
                <div className='question-text'>{`${item.index}. ${item.question_text}`}</div>
                <div className='answer-container'>
                    <Radio.Group defaultValue={item.is_selected} options={[{ label: "Yes", value: true, disabled: true }, { label: "No", value: false, disabled: true }]} />
                </div>
            </div>
        )
    }

    componentDidMount() {
        this.getSummaryList()
    }

    render() {
        return (
            <>
            {this.state.isLoading ? (
              <Loader />
            ) : (
            <div className="dsm-screening-wrapper-container">
                <div className='dsm-screening-header'>
                    <div>{CONSTANTS.DSM_SCREENING}</div>
                </div>
                <div className='dsm-content' style={this.state.data.dsm_types?.length==0?{overFlow:"hidden"}:{} }>
                {this.props.data?.user_type == "adult"||this.props?.data?.user_type=="senior_adult" ? <>               
                        {this.state.data.length > 0 ? 
                        (this.state.data || []).map((e,i)=>{
                                           
                                            if(e.dsm_types.length>0)
                                              {  return(                                      
                                                    <Collapse bordered={true} expandIconPosition="start" ghost={true} className='prescription-list-container'key={i}>
                                                        <Panel header={<div>{utils.FormatDate(e.completion_date, "DATE_14")}, {utils.FormatDate(e.completion_date, "TIME_1")} </div> } extra={utils.FirstNameLastName(utils.salutationPrefixName(e?.doctor_salutation,utils.getDisplayName(e?.consultation_doctor, e?.doctor_last_name)), "250px")}
                                                        >
                                                                <Card title="Types">
                                                                <ul>
                                                                {e.dsm_types.map((m,j) => { 
                                                                    return (
                                                                        <li key={j} style={{ margin: "5px" }}>{utils.ConvertToPascalCase(m).split("|").join(" - ")}</li>
                                                                    )
                                                                })}   
                                                                </ul> 
                                                                </Card>
                                                                                                                                                                                           
                                                        </Panel>
                                                    </Collapse>                                              
                                            )}
                                            else{
                                                return(
                                                    <Collapse bordered={true} expandIconPosition="start" ghost={true} className='prescription-list-container'key={i}>
                                                        <Panel header={<div>{utils.FormatDate(e.completion_date, "DATE_14")}, {utils.FormatDate(e.completion_date, "TIME_1")} </div> } extra={utils.FirstNameLastName(utils.salutationPrefixName(e?.doctor_salutation,utils.getDisplayName(e?.consultation_doctor, e?.doctor_last_name)), "250px")}>                                                                
                                                        <div>
                                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                                        </div>
                                                        </Panel>
                                                    </Collapse>
                                                )
                                            }                                         
                                }) :  (
                                    <div className='chart-noData-card'>
                                        <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        </div>
                                    </div>
                                  )
                            } 
                      
                </> :
                 <>
                 {this.state.data.length > 0 ? 
                  (this.state.data || []).map((e,i)=>{
                                            let obj = {}
                                            for(let x in e.data?.is_limit){
                                               if(e.data?.is_limit[x] == true){
                                                 obj[x] =  e.data?.is_limit[x]
                                               }
                                            }
                                            if(Object.keys(obj).length>0)
                                              {  return(
                                                    <Collapse bordered={true} expandIconPosition="start" ghost={true} className='prescription-list-container'key={i}>
                                                        <Panel header={<div>{utils.FormatDate(e.completion_date, "DATE_14")}, {utils.FormatDate(e.completion_date, "TIME_1")} </div> } extra={utils.FirstNameLastName(utils.salutationPrefixName(e?.doctor_salutation,utils.getDisplayName(e?.consultation_doctor, e?.doctor_last_name)), "250px")}>
                                                        <Card title="Types">
                                                                <ul>
                                                                {Object.keys(obj).map((m,j) => { 
                                                                    return (
                                                                        <li key={j} style={{ margin: "5px" }}>{utils.ConvertToPascalCase(m).split("|").join(" - ")}</li>
                                                                    )
                                                                })} 
                                                                </ul>  
                                                        </Card>                                                               
                                                        </Panel>
                                                    </Collapse>
                                            )}
                                            else{
                                                return(
                                                    <Collapse bordered={true} expandIconPosition="start" ghost={true} className='prescription-list-container'key={i}>
                                                        <Panel header={<div>{utils.FormatDate(e.completion_date, "DATE_14")}, {utils.FormatDate(e.completion_date, "TIME_1")} </div> } extra={utils.FirstNameLastName(utils.salutationPrefixName(e?.doctor_salutation,utils.getDisplayName(e?.consultation_doctor, e?.doctor_last_name)), "250px")}>                                                                
                                                        <div>
                                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                                        </div>
                                                        </Panel>
                                                    </Collapse>
                                                )
                                            }
                                           
                                   
                                }) :  (
                                    <div className='chart-noData-card'>
                                        <div>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        </div>
                                    </div>
                                  )
                            } 
                 </>
                 }  
                 </div> 
            </div>
            )}
            </>
        );
    }
}